import * as Yup from "yup";
export const validatePhoneNumber = (number) => {
  if (!number) return false;
  let filter;

  let n;
  if (number.startsWith("+91")) {
    n = number.replaceAll("+", "");
    filter = /^(\d{12})$|^(1800(\d{6}|\d{7}|\d{8}))$|^(1888(\d{6}|\d{7}|\d{8}))$/;
  } else {
    n = number.replaceAll("+", "");
    filter = /^(\d{8,14})$|^(1800(\d{6}|\d{7}|\d{8}))$|^(1888(\d{6}|\d{7}|\d{8}))$/;
  }

  return Yup.string()
    .matches(filter)
    .isValidSync(n);
};
